import { useEffect, useRef, useState } from "react";
import FormDropDown from "../../../forms/DropDownList/FormDropDown";
import "./ExpeditionControls.scss";
import { convertMSToHMS } from "../../../../helpers/Dates";
import TabbedPanel from "../../../TabbedPanel/TabbedPanel";
import EXPEDITION_LIVE_STATE from "./ExpeditionLiveState";
import HMSTimeField from "../../../forms/HMSTimeField/HMSTimeField";

const ExpeditionManagerControls = (props) => {
    const [buttonClickedWaitingForUpdate, setButtonClickedWaitingForUpdate] = useState(false);
    const [registerButtonClickedWaitingForUpdate, setRegisterButtonClickedWaitingForUpdate] = useState(false);
    const expeditionDataFetched = props.expeditionDataFetched;

    // console.log('--- ExpeditionControls, props: ', props);
    const primaryStream = props.featureVars.manageExpeditionControls.masterStream;

    const [tick, setTick] = useState(0);
    const forceUpdate = () => setTick(tick + 1);

    const getStateData = () => {
        let stateData = null;
        if (props.previewControls && props?.passedInPreviewData?.expeditionState) {
            stateData = props.passedInPreviewData.expeditionState;
        }
        if (!props.previewControls && expeditionDataFetched) {
            stateData = EXPEDITION_LIVE_STATE.expeditionMainState;
        }
        /* if (stateData === null) {
            stateData = props?.featureVars?.expeditionState;
        } */
        if (stateData) {
            console.log('--- ExpeditionControls, stateData: ', stateData);
            return stateData;
        }
        // Default state data
        return {
            expeditionInited: false,
        };
    }

    const stateData = getStateData();

    const [lastUpdate, setLastUpdate] = useState(0);
    const updateReceivedCallback = (newExpeditionState, sentData) => {
        // console.log('--- ExpeditionControls, updateReceivedCallback: ', data);
        setLastUpdate(Date.now());
    }
    useEffect(() => {
        EXPEDITION_LIVE_STATE.registerUpdateListener(updateReceivedCallback);
        if (stateData && stateData.expeditionInited) {
            registerForLiveUpdates();
        }
        return () => {
            EXPEDITION_LIVE_STATE.unregisterUpdateListener(updateReceivedCallback);
        }
    }, []);

    const [timeAllowed, setTimeAllowed] = useState(60 * 60 * 2); // Default to 2 hours

    const featureIdForCommands = props.previewControls ? 'previewFrame' : props.featureId;
    const initPreviewExpedition = () => {
        console.log('--- ExpeditionControls, initPreviewExpedition');
        setButtonClickedWaitingForUpdate(true);
        props.sendFeatureCommandFunc(null, "INIT_EXPEDITION", featureIdForCommands, {isPreview: props.previewControls});
        if (props.forceUpdate) props.forceUpdate();
    }
    const expeditionInitedCallback = () => {
        setTimeout(() => {
            // EXPEDITION_LIVE_STATE.registerAsPrimaryStream(props.streamId);
            // EXPEDITION_LIVE_STATE.registerForLiveUpdates(props.streamId);
            // registerForLiveUpdates();
            forceUpdate();
        }, 500);
    }
    const initLiveExpedition = () => {
        console.log('--- ExpeditionControls, initLiveExpedition');
        setButtonClickedWaitingForUpdate(true);

        EXPEDITION_LIVE_STATE.initializeSocket(props.socket);
        EXPEDITION_LIVE_STATE.activateNewExpedition(props.campaignId, props.streamId, props.featureId, props.customAssetBaseUrl, props.defaultAssetBaseUrl, props?.customisationData, expeditionInitedCallback);

        console.log('--- ExpeditionControls, initLiveExpedition done', EXPEDITION_LIVE_STATE);

        if (props.forceUpdate) props.forceUpdate();
    }
    const recoverLiveExpedition = () => {
        console.log('--- ExpeditionControls, recoverLiveExpedition');
        setButtonClickedWaitingForUpdate(true);
        EXPEDITION_LIVE_STATE.initializeSocket(props.socket);
        const recoveredDataCallBack = (recoveredState) => {
            if (recoveredState && recoveredState.expeditionInited) {
                EXPEDITION_LIVE_STATE.activateRecoveredExpedition(props.campaignId, props.streamId, recoveredState, expeditionInitedCallback);
            } else {
                alert('No active expedition could be found to recover!');
            }
        }
        EXPEDITION_LIVE_STATE.recoverExpeditionData(props.campaignId, recoveredDataCallBack);
    }

    const registerForLiveUpdates = () => {
        console.log('--- ExpeditionControls, registerForLiveUpdates');
        EXPEDITION_LIVE_STATE.initializeSocket(props.socket);
        EXPEDITION_LIVE_STATE.registerForLiveUpdates(props.streamId);
        if (primaryStream) {
            EXPEDITION_LIVE_STATE.registerAsPrimaryStream(props.streamId);
        }
        setTimeout(() => {
            forceUpdate();
        }, 500);
    }

    const startPreviewExpedition = (timeAllowed = 60 * 60 * 2) => {
        console.log('--- ExpeditionControls, startPreviewExpedition');
        setButtonClickedWaitingForUpdate(true);
        props.sendFeatureCommandFunc(null, "START_EXPEDITION", featureIdForCommands, {isPreview: props.previewControls, timeAllowed});
        if (props.forceUpdate) props.forceUpdate();
    }
    const startLiveExpedition = (timeAllowed = 60 * 60 * 2) => {
        console.log('--- ExpeditionControls, startLiveExpedition');
        setButtonClickedWaitingForUpdate(true);
        EXPEDITION_LIVE_STATE.startExpedition(timeAllowed, forceUpdate);
        if (props.forceUpdate) props.forceUpdate();
    }

    const deactivateLiveExpedition = () => {
        console.log('--- ExpeditionControls, deactivateLiveExpedition');
        setButtonClickedWaitingForUpdate(true);
        EXPEDITION_LIVE_STATE.deactivateExpedition(forceUpdate);
        if (props.forceUpdate) props.forceUpdate();
    }

    useEffect(() => {
        // If the expedition state has changed, and we were waiting for an update, stop waiting
        if (buttonClickedWaitingForUpdate || registerButtonClickedWaitingForUpdate) {
            setButtonClickedWaitingForUpdate(false);
            setRegisterButtonClickedWaitingForUpdate(false);
            if (props.forceUpdate) props.forceUpdate();
        }
    }, [stateData, stateData.expeditionInited, stateData.expeditionActive, stateData.expeditionStartTime]);

    return (
        <div className="generic-feature-status fl-column">
            {props.previewControls &&
                <>
                    <div className={`generic-feature-status-main-header warning`}>
                        - PREVIEW MODE -
                    </div>
                    <div className="light-text bold-text">In Preview Mode you will be working with temporary expedition data in order to simulate what will happen in Live Mode.</div>

                    {!stateData.expeditionInited &&
                        <>
                            <div className={`generic-feature-status-main-header inactive`}>
                                - Not Initialized -
                            </div>
                            <div className="light-text bold-text">Your Expedition needs to be initialized before we can start!</div>
                            {primaryStream &&
                                <div className="button-grid">
                                    <button className={`standard-button ${!buttonClickedWaitingForUpdate ? 'live-but-orange' : 'button-inactive'}`} onClick={!buttonClickedWaitingForUpdate ? initPreviewExpedition : null}>{!buttonClickedWaitingForUpdate ? 'Initialize Now' : 'Initializing...'}</button>
                                </div>
                            }
                            {!primaryStream &&
                                <div className="light-text bold-text warning-text">Only the Primary Stream can initialize the expedition.</div>
                            }
                        </>
                    }
                    {stateData.expeditionInited && !stateData.expeditionActive && stateData.expeditionStartTime === 0 &&
                        <>
                            <div className={`generic-feature-status-main-header warning`}>
                                - Ready to Start -
                            </div>
                            <div className="light-text bold-text">Your Expedition is ready to start! Note in preview mode your expedition will be set to 2 hours in length, in live mode you can set this before you start the expedition.</div>
                            {primaryStream &&
                                <>
                                    <HMSTimeField
                                        id="timeAllowed"
                                        label="Time Allowed"
                                        value={timeAllowed}
                                        setFunc={setTimeAllowed}
                                        hideLabel={false}
                                    />
                                    <div className="button-grid">
                                        <button className={`standard-button ${!buttonClickedWaitingForUpdate ? 'live-but-green' : 'button-inactive'}`} onClick={!buttonClickedWaitingForUpdate ? () => startPreviewExpedition(timeAllowed) : null}>{!buttonClickedWaitingForUpdate ? 'Start Now' : 'Starting...'}</button>
                                    </div>
                                </>
                            }
                            {!primaryStream &&
                                <div className="light-text bold-text warning-text">Only the Primary Stream can start the expedition.</div>
                            }
                        </>
                    }
                    {stateData.expeditionInited && stateData.expeditionActive && 
                        <>
                            <div className={`generic-feature-status-main-header inactive`}>
                                - Expedition Active -
                            </div>
                            <div className="light-text bold-text">Your Expedition is currently active!</div>
                        </>
                    }
                </>
            }
            {!props.previewControls &&
                <>
                    {!primaryStream &&
                        <>
                            <div className={`generic-feature-status-main-header inactive`}>
                                - TEAM STREAM MODE -
                            </div>
                            <div className="light-text bold-text">In Team Stream Mode you will only have access to controls appropriate to your team.</div>
                            {(!expeditionDataFetched || (expeditionDataFetched && (stateData === null || !stateData.expeditionInited))) &&
                                <>
                                    <div className={`generic-feature-status-main-header inactive`}>
                                        - Waiting for Expedition Data -
                                    </div>
                                    <div className="light-text bold-text">Please wait for the Expedition Manager to initialize the expedition.</div>
                                </>
                            }
                            {expeditionDataFetched && stateData && stateData.expeditionInited && !stateData.expeditionActive && stateData.expeditionStartTime === 0 &&
                                <>
                                    <div className={`generic-feature-status-main-header warning`}>
                                        - Waiting to Start -
                                    </div>
                                    <div className="light-text bold-text">Expedition is ready to start! Please wait for the Expedition Manager to start the expedition.</div>
                                </>
                            }
                            {expeditionDataFetched && stateData && stateData.expeditionInited && stateData.expeditionActive && 
                                <>
                                    <div className={`generic-feature-status-main-header active`}>
                                        - Expedition Active -
                                    </div>
                                    <div className="light-text bold-text">Expedition is currently active!</div>
                                </>
                            }
                            <div className="button-grid">
                                <button className={`standard-button ${!buttonClickedWaitingForUpdate ? '' : 'button-inactive'}`} onClick={!buttonClickedWaitingForUpdate ? registerForLiveUpdates : null}>{!buttonClickedWaitingForUpdate ? 'Register Stream' : 'Registering...'}</button>
                            </div>
                        </>
                    }
                    {primaryStream &&
                        <>
                            <div className={`generic-feature-status-main-header warning`}>
                                - PRIMARY STREAM MODE -
                            </div>
                            <div className="light-text bold-text">In Primary Stream Mode you will be working with real expedition data. Note only one expedition can be run on icast at a time - care should be taken when making changes to the expedition state as mistakes can not be undone!</div>
                            {!expeditionDataFetched &&
                                <>
                                    <div className={`generic-feature-status-main-header inactive`}>
                                        - Waiting for Expedition Data -
                                    </div>
                                </>
                            }
                            {expeditionDataFetched && 
                                <>
                                    {(stateData === null || !stateData.expeditionInited) &&
                                        <>
                                            <div className={`generic-feature-status-main-header inactive`}>
                                                - Not Initialized -
                                            </div>
                                            <div className="light-text bold-text">Your Expedition needs to be initialized before we can start!</div>
                                            <div className="button-grid">
                                                <button className={`standard-button ${!buttonClickedWaitingForUpdate ? 'live-but-orange' : 'button-inactive'}`} onClick={!buttonClickedWaitingForUpdate ? initLiveExpedition : null}>{!buttonClickedWaitingForUpdate ? 'Initialize Now' : 'Initializing...'}</button>
                                            </div>
                                            <div className="button-grid">
                                                <button className={`standard-button ${!buttonClickedWaitingForUpdate ? 'live-but-red' : 'button-inactive'}`} onClick={!buttonClickedWaitingForUpdate ? recoverLiveExpedition : null}>{!buttonClickedWaitingForUpdate ? 'Recover Active Expedition' : 'Recovering...'}</button>
                                            </div>
                                        </>
                                    }
                                    {stateData && stateData.expeditionInited && !stateData.expeditionActive && stateData.expeditionStartTime === 0 &&
                                        <>
                                            <div className={`generic-feature-status-main-header warning`}>
                                                - Ready to Start -
                                            </div>
                                            <div className="light-text bold-text">Your Expedition is ready to start!</div>
                                            <HMSTimeField
                                                id="timeAllowed"
                                                label="Time Allowed"
                                                value={timeAllowed}
                                                setFunc={setTimeAllowed}
                                                hideLabel={false}
                                            />
                                            <div className="button-grid">
                                                <button className={`standard-button ${!buttonClickedWaitingForUpdate ? 'live-but-green' : 'button-inactive'}`} onClick={!buttonClickedWaitingForUpdate ? () => startLiveExpedition(timeAllowed) : null}>{!buttonClickedWaitingForUpdate ? 'Start Now' : 'Starting...'}</button>
                                            </div>
                                        </>
                                    }
                                    {stateData.expeditionInited && stateData.expeditionActive && 
                                        <>
                                            <div className={`generic-feature-status-main-header active`}>
                                                - Expedition Active -
                                            </div>
                                            <div className="light-text bold-text">Your Expedition is currently active!</div>
                                        </>
                                    }
                                    {stateData.expeditionInited && 
                                        <>
                                            <div className="light-text bold-text">Click the button below to deactivate the expedition. This will end the expedition immediately.</div>
                                            <div className="button-grid">
                                                <button className={`standard-button ${!buttonClickedWaitingForUpdate ? 'live-but-red' : 'button-inactive'}`} onClick={!buttonClickedWaitingForUpdate ? deactivateLiveExpedition : null}>{!buttonClickedWaitingForUpdate ? 'Deactivate Now' : 'Deactivating...'}</button>
                                            </div>
                                        </>
                                    }
                                    {stateData.expeditionInited &&
                                        <>
                                            <div className="light-text bold-text">Click the button below if you believe you have lost connection to the live expedition. This will also request a heartbeat to be sent from the backend to all other clients.</div>
                                            <div className="button-grid">
                                                <button className={`standard-button ${!registerButtonClickedWaitingForUpdate ? '' : 'button-inactive'}`} onClick={!registerButtonClickedWaitingForUpdate ? () => {setRegisterButtonClickedWaitingForUpdate(true); registerForLiveUpdates();} : null}>{'Register As Primary Stream'}</button>
                                            </div>
                                            <div className="light-text tiny-text italic-text">Last Update: {lastUpdate > 0 ? new Date(lastUpdate).toLocaleTimeString() : 'N/A'}</div>
                                        </>
                                    }
                                </>
                            }
                        </>
                    }
                </>
            }
        </div>
    )
}

export default ExpeditionManagerControls;
